/* eslint-disable @next/next/no-img-element */
// --- components/about/AboutWhoWeAre.tsx ---
'use client';
import React from 'react';
import Image from 'next/image';

export const AboutWhoWeAre: React.FC = () => ( // Props removed
  <div
    className="mb-12 md:mb-16 w-full"
  >
    <p className="text-gray-400 text-lg font-semibold mb-2">WHO WE ARE</p>
    <h2 className="text-3xl sm:text-4xl font-medium mb-4 text-left">
      Samsan Inc: Delivering Reliable Industrial Solutions, End-to-End.
    </h2>
    <div className="flex flex-col md:flex-row gap-8">
      <p className="text-lg sm:text-xl text-gray-300 leading-relaxed md:w-1/2 text-left">
        Samsan Inc. is a premier supplier of industrial and engineering products serving critical sectors such as oil & gas, manufacturing, utilities, and construction. With decades of combined experience and a global sourcing network, we provide reliable solutions that keep industries moving.
      </p>
      <div className="md:w-1/2 flex justify-center md:justify-end">
        <Image
          src="https://images.unsplash.com/photo-1617817546276-80b86dd60151?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" // New image placeholder
          alt="Industrial Containers"
          width={870}
          height={580}
          className="w-full h-auto rounded-lg shadow-xl"
        />
      </div>
    </div>
    <p className="text-lg sm:text-xl text-gray-300 leading-relaxed mt-8 text-left">
      We simplify industrial logistics with advanced technology, so you can focus on business growth.
    </p>
  </div>
);